// extracted by mini-css-extract-plugin
export default {"playerhandbook":"RichTextEditor_playerhandbook__X5B+5","ql-editor":"RichTextEditor_ql-editor__lIuuH"};